function getValue(value) {
    if (value == null || value === 'null') {
        return null;
    }
    return value;
}

export default function parseJerseys(data, sportId) {
    let result = null;
    if (data != null) {
        result = data.map(j => {
            return {
                ...j,
                shirtType: getValue(j.shirtType),
                sleeveDetail: getValue(j.sleeveDetail),
                splitColor: getValue(j.splitColor),
                sportRef: sportId,
                stripesColor: getValue(j.stripesColor)
            }
        });
    }
    return result;
}
